export const IN_HOUSE_REPORT_ENDPOINT = `report/in-house`;
